import { isString } from 'lodash'

import { GenericalRecord } from '../../../types/utilities'
import { LinkType } from '../interface'

export const resolveLink = (
  link: LinkType<GenericalRecord>,
  value: unknown,
  record: GenericalRecord,
  index: number
) => {
  const result = link(value, record, index)

  return isString(result)
    ? {
        to: result
      }
    : result
}
